import { render, staticRenderFns } from "./ApiLoader.vue?vue&type=template&id=2233f1dc&scoped=true"
import script from "./ApiLoader.vue?vue&type=script&lang=js"
export * from "./ApiLoader.vue?vue&type=script&lang=js"
import style0 from "./ApiLoader.vue?vue&type=style&index=0&id=2233f1dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2233f1dc",
  null
  
)

export default component.exports